import React, { useEffect, useState } from "react";
import { Grid, useTheme } from "@material-ui/core";
import ProductItem from "../Products/productItem";
import checkOut from "../../../assets/icons/checkOut.png";
import Badge from "@material-ui/core/Badge";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import { useSelector, useDispatch } from "react-redux";
import {
    addProductQuantity,
  addProductToCart,
  decreaseProductQuantity,
  removeProductFromCart,
  startTimer,
} from "../../../redux/actions";
import _ from "lodash";
import { useHistory } from "react-router-dom";


const StyledBadge = withStyles((theme) => ({
  badge: {
    right: 28,
    top: 20,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
    color: "white",
  },
}))(Badge);

const ProductsList = ({ productsList }) => {
  const dispatch = useDispatch();

  const theme = useTheme();

  const cartItems = useSelector((state) => state.touchless.cart_items);

  const history = useHistory();

  // const { enqueueSnackbar } = useSnackbar();

  const addToCart = (product) => {
    dispatch(addProductToCart(product));
  };

  const addProductQty = (id) => {
    dispatch(addProductQuantity(id));
  };

  const decreaseProductQty = (id) => {
    dispatch(decreaseProductQuantity(id));
  };

  const removeFromCart = (id) => {
    dispatch(removeProductFromCart(id));
  };

  const handleCart = (product, isSelected) => {
    const quantity = _.find(cartItems, (x) => x.id === product.id)?.quantity;
    if (isSelected) {
      if (quantity === 1) {
        removeFromCart(product.id);
      } else {
        decreaseProductQty(product.id);
      }
    } else {
      if (!quantity || quantity < 0) {
        addToCart(product);
      } else {
        addProductQty(product.id);
      }
    }
  };

  const handleCheckoutClick = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const serial_no = urlParams.get("serial_no");

    history.push(`/webstore/cart?serial_no=${serial_no}`);
  };



  return (
    <div>
      <Grid style={{ flex: 1 }} container>
        {productsList.map((val) => {
          return (
            <ProductItem
              key={val.id}
              productImage={val.product_picture}
              productName={val.product_name}
              productDetail={val.detail}
              product={val}
              isSelected={_.find(cartItems, (x) => x.id === val.id)?.quantity > 0}
              productPrice={val.price}
              totelProductCart={cartItems.length}
              onAdd={(product) => addToCart(product)}
              onRemove={(id) => removeFromCart(id)}
              stock={val.stock}
              onIncrement={(id) => addProductQty(id)}
              onDecrement={(id) => decreaseProductQty(id)}
              onClick={handleCart}
            />
          );
        })}

        {cartItems.length > 0 && (
          <IconButton
            aria-label="cart"
            onClick={handleCheckoutClick}
            style={{
              position: "fixed",
              bottom: "10vh",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            <StyledBadge badgeContent={cartItems.reduce((sum, item) => sum + item?.quantity, 0)}>
              <Grid style={{ height: 59, width: 76 }}>
                <Grid
                  style={{
                    backgroundImage: `url(${checkOut})`,
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    height: "100%",
                    width: "100%",
                  }}
                ></Grid>
              </Grid>
            </StyledBadge>
          </IconButton>
        )}
      </Grid>
    </div>
  );
};

export default ProductsList;
